<template>
  <vx-card no-shadow>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-2/5 w-full">
        <h2>Danger Zone</h2>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Delete Campaign</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-button color="danger" v-if="isEditable && $AuthService.hasPermissionForActiveVenue('vp.crm.campaigns.edit')" @click="confirmDelete" class="ml-auto mt-2"
          >Delete Campaign</vs-button
        >
        <h5 class="my-5" v-if="!isEditable">
          <b
            >Can no longer be deleted as campaign has status
            {{ masterStatusObject(masterCampaign.masterStatus).text }}.</b
          >
        </h5>
      </div>
    </div>
  </vx-card>
</template>

<script>
import campaignMixin from "@/views/mixins/campaignMixin";

export default {
  components: {},
  mixins: [campaignMixin],
  props: ["masterCampaign", "isEditable"],
  methods: {
    confirmDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this Campaign?",
        accept: this.deleteCampaign,
      });
    },
    async deleteCampaign() {
      await this.$store.dispatch("masterCampaigns/delete", this.masterCampaign.id);
      this.$vs.notify({
        color: "success",
        title: "Success",
        text: "Campaign deleted",
      });
      this.$router.go(-1);
    },
  },
};
</script>